import "react-json-view-lite/dist/index.css";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  Paper,
  Stack,
  Typography
} from "@mui/material";
import { JsonView } from "react-json-view-lite";

import CopyButton from "../../../components/CopyButton";

interface ArtifactsTabProps {
  data: Record<string, any> | null;
  isLoading: boolean;
}

const ArtifactsTab = ({ data, isLoading }: ArtifactsTabProps) => {

  if (isLoading) {
    return <CircularProgress />;
  }

  if (!data) {
    return <Typography>No artifact data available</Typography>;
  }

  // Extract artifacts with content fields
  const artifactEntries = Object.entries(data)
    .filter(([, value]) => value && typeof value === "object" && "content" in value)
    .map(([key, value]) => ({
      name: key,
      content: value.content
    }));

  if (artifactEntries.length === 0) {
    return <Typography>No artifacts with content found</Typography>;
  }

  return (
    <Stack spacing={2}>
      <Typography variant="h6">Raw Artifact Data</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Expand each section to view the raw JSON data for each artifact
      </Typography>

      {data.all.map((artifact: any, index: number) => {
        const jsonString = JSON.stringify(artifact.content, null, 2);

        return (
          <Accordion
            key={index}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`${artifact.type}-content`}
              id={`${artifact.type}-header`}
            >
              <Typography>{artifact.type}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  position: "relative",
                  maxHeight: "500px",
                  overflow: "auto"
                }}
              >
                <Box sx={{ position: "absolute", top: 8, right: 8 }}>
                  <CopyButton text={jsonString} tooltipTitle={`Copy ${artifact.name} JSON`} richText={false} />
                </Box>
                <JsonView data={artifact.content} />
              </Paper>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Stack>
  );
};

export default ArtifactsTab;
